
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jumpstart-mw-ca-trial",
      function () {
        return require("private-next-pages/jumpstart-mw-ca-trial/index.js");
      }
    ]);
  